
import React, {useContext, useEffect, useRef, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import strings from '../../lang/strings'
import {observer} from 'mobx-react'
import SidebarLeft from '../../components/sidebar/sidebar_left'
import AppInput from '../../components/control/custom_input/app_input'
import ConfirmButton from '../../components/control/button/confirm_button'
import ItemCs from '../../components/item/item_cs'
import {MenuCs} from '../../config/page_route'
import {rootStore} from '../../mobx/store'
import {customDateTimeFormat} from '../../helper/common'
const OneToOne = observer((props) => {
  const context = useContext(Page_settings)
  const fileRef = useRef()
  let [tab, setTab] = useState(0)
  let [title, setTitle] = useState('')
  let [category, setCategory] = useState(1)
  let [content, setContent] = useState('')
  let [attachFile, setAttachFile] = useState('')
  let [titleError, setTitleError] = useState('')
  let [contentError, setContentError] = useState('')
  let [csList, setCsList] = useState([])
  let [file, setFile] = useState(null)
  let [empty, setEmpty] = useState(false)
  const categoryList = [strings.etc, strings.trade, strings.account, strings.payment, strings.error, strings.fraud, strings.service, strings.exit, strings.normal]


  useEffect(() => {
    getCs()
  }, [])

  const getCs = () => {
    context.post('cs/cs_list', {},
      response => {
        setCsList(response.list)
        setEmpty(response.list.length == 0)
        let mb = rootStore.getMe
        mb.mb_point = response.mb_point
        rootStore.signIn(mb)
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  useEffect(() => {
    setTitleError('')
  }, [title])

  useEffect(() => {
    setContentError('')
  }, [content])

  const onSave = () => {
    let checked = true
    if (title.length < 1 || title.length > 20) {
      checked = false
      setTitleError(strings.title_error)
    }
    if (content.length < 1 || content.length > 500) {
      checked = false
      setContentError(strings.content_error)
    }
    if (!checked) return
    if (file) {
      let formData = new FormData()
      formData.append('folder', 'cs')
      formData.append('upload[0]', file)
      context.post('upload/upload_files',
        formData,
        response => {
          onCs(response.file_urls.join(','))
        },
        true,
        err => {
          context.showAlert(err.msg)
        }
      )
    } else {
      onCs('')
    }
  }

  const onCs = (file_path) => {
    context.post('cs/cs_do', {cs_cate: category, cs_title: title, cs_note: content, cs_file: file_path},
      () => {
        context.showAlert(strings.cs_do, function () {
          setTitle('')
          setCategory(1)
          setContent('')
          setAttachFile('')
          setFile(null)
          getCs()
          setTab(1)
        })
      },
      true,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  const uploadFile = (event) => {
    if (event.target.files.length < 1) {
      setAttachFile('')
      setFile(null)
      return
    }

    let file = event.target.files[0]
    setAttachFile(file.name)
    setFile(file)
  }

  return (
    <React.Fragment>
        <div className={'mt-30'}>
          <div className='d-flex align-items-center'>
            <div onClick={() => { setTab(0)}} className={'fs-28 sm-fs-20 f-b cursor-point ' + (tab === 0 ? '' : 'color-9e9e9e')}>{strings.asking}</div>
            <div className='title-divider'/>
            <div onClick={() => { setTab(1)}} className={'fs-28 sm-fs-20 f-b cursor-point ' + (tab === 1 ? '' : 'color-9e9e9e')}>{strings.ask_list}</div>
            <div className='flex-full' />
            <div className='fs-13 color-9e9e9e ml-10 sm-none'>{strings.main}<img className='a4_r' src={'/assets/image/a4_r.png'} alt='' />{strings.cs_center}</div>
            <img className='a4_r sm-none' src={'/assets/image/a4_r.png'} alt='' />
            <div className='fs-13 sm-fs-20 f-m sm-none'>{strings.asking}</div>
          </div>
          <div className='term-content-area'>
            {
              tab === 0 &&
                <React.Fragment>
                  <label className='control-label'>{strings.title}<span className='text-danger'>*</span></label>
                  <AppInput className={''} errorMsg={titleError} placeholder={strings.title_hint} inputType={'text'} maxLength={30} value={title} onChange={(v) => { setTitle(v) }} />
                  <label className='control-label mt-24 sm-mt-18'>{strings.category}<span className='text-danger'>*</span></label>
                  <select className='form-control select-cs w-50' onChange={(e) => { setCategory(e.target.value)}}>
                    {categoryList.map((it, idx) => {return (<option value={idx + 1} key={idx}>{it}</option>)})}
                  </select>
                  <label className='control-label mt-24 sm-mt-18'>{strings.ask_content}<span className='text-danger'>*</span></label>
                  <textarea className={'form-control '  + (contentError !== '' ? 'error' : '')} placeholder={strings.ask_content_hint} maxLength={500} onChange={(e) => setContent(e.target.value)} rows={5}/>
                  <div className={'invalid-feedback ' + (contentError !== '' ? 'error' : '')}>{contentError}</div>
                  <label className='control-label mt-24 sm-mt-18'>{strings.file_attach}</label>
                  <div className='d-flex-block width-full'>
                    <AppInput className='w-50' errorMsg={''} placeholder={strings.file_attach_name} inputType={'text'} value={attachFile} onChange={(v) => {}} />
                    <ConfirmButton enabled={true} className={'btn-attach fs-15 sm-fs-14 f-sb ml-4'} onClick={() => {fileRef?.current.click()}} text={strings.file_attach} />
                  </div>
                  <ConfirmButton enabled={true} className={'btn-save mt-60 sm-mt-40 fs-15 f-sb width-full'} onClick={onSave} text={strings.asking} />
                  <input type='file' ref={fileRef} onChange={uploadFile} hidden={true} accept='image/*'/>
                </React.Fragment>
            }
            {
              tab === 1 &&
                <React.Fragment>
                  {csList.map((it, idx) => {return (<ItemCs key={idx} info={it} cate={categoryList}/>)})}
                </React.Fragment>
            }
            {tab === 1 && empty && <div className='d-center color-3a3335 fs-16 f-b empty_label hx-100'>{strings.empty_cs}</div>}
          </div>
        </div>
    </React.Fragment>
  )
})

export default withRouter(OneToOne)